import { PageViewLoggerKeys } from '../loggers/PageViewLogger';
var UBIPageIdProvider = (function () {
    function UBIPageIdProvider(options) {
        this.storageManager = options.storageManager;
    }
    UBIPageIdProvider.prototype.getPageId = function () {
        return this.storageManager.getItem(PageViewLoggerKeys.CURRENT_PAGE_ID);
    };
    UBIPageIdProvider.prototype.setPageId = function (pageId) {
        this.storageManager.setItem(PageViewLoggerKeys.CURRENT_PAGE_ID, pageId);
    };
    return UBIPageIdProvider;
}());
export { UBIPageIdProvider };
//# sourceMappingURL=PageIdProvider.js.map